<template>
    <div>
        <login-modal :show="showModal" @close="close" redirect="checkout">
            <div class="alert alert-warning">
                <strong>You've been logged out.</strong><br>
                <p>You will be taken back to the basket page to check your order after you log back in.</p>
            </div>
        </login-modal>
    </div>
</template>
<script>
    import LoginModal from './Modals/LoginModal.vue';
    export default {
        components: {
            LoginModal
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            user: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                showModal: false,
                interval: null
            }
        },
        mounted() {
            if (this.user && !this.show) {
                this.interval = setInterval(this.check, 5000);
            }
        },
        methods: {
            close() {
                this.showModal = false;
                this.$emit('close');
            },
            check() {
                axios.get('/api/user').then(response => {
                    if (response.data.guest) {
                        // Because of CSRF we have to refresh.
                        // location.reload();
                        this.showModal = true;
                        this.stop();
                    }
                });
            },
            stop() {
                clearInterval(this.interval);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/LoginChecker.vue